module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"logout":"Log out"},"zh":{"logout":"退出登录"}}')
  delete Component.options._Ctor
}
